import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import TopHeader from '../../../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { PvMonitoringContext } from '../../../../../../context/PvMonitoringContext';
import { PASS_KEY, WEB_KEY } from '../../../../../../api/AxiosApi';
import Tab8ChartContent from './Tab8ChartContent';
import Tab8LogContent from './Tab8LogContent';



export default function PlantGeneration() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    // const [FromDate, setFromDate] = useState(getDateTimeForTab3().LastDay)
    // const [ToDate, setToDate] = useState(getDateTimeForTab3().Today)

    const [key, setKey] = useState('Chart');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }

    return (
        <Box>
           
            <Box mt={spacing(1)}>
               
                <Tabs
                    style={{ justifyContent: "flex-start" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    
                    <Tab eventKey="Chart" title="Chart">
                    <Tab8ChartContent/>
                    
                    </Tab>

                    <Tab eventKey="Log" title="Log">
                    <Tab8LogContent/>
                    {/* <PrAnalysisTab1/> */}
                    </Tab>


                    
                </Tabs>
            </Box>
        </Box>

    )
}